import React from 'react';
import { useGLTF } from '@react-three/drei';

export const SUZI_MODEL_URL =
  "https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/suzanne-high-poly/model.gltf";

interface SuziProps {
  rotation?: [number, number, number];
  scale?: number;
}

function Suzi({ rotation, scale, ...props }: SuziProps) {
  const { nodes } = useGLTF(SUZI_MODEL_URL);
  
  return (
    <mesh 
      castShadow 
      receiveShadow 
      geometry={(nodes as any).Suzanne.geometry} 
      rotation={rotation}
      scale={scale}
      {...props}
    >
      <meshStandardMaterial color="#6d3434" />
    </mesh>
  );
}

export default Suzi;
